import http from '@/api/http'

export default {
    saveReport(cb, request) {
        http.post('/api/portal-web/research-report/new/save', cb, request);
    },
    getActiveList(cb, form) {
        http.get('/api/careers/getActiveCareersList', cb, form)
    },
}